import { useEffect } from "react";
import { useCssVar } from "./useCssVar";

export function useFavicon() {
	const faviconPath = useCssVar("--favicon-path");

	useEffect(() => {
		if (!faviconPath) return;

		const link =
			document.querySelector("link[rel*='icon']") ||
			document.createElement("link");

		link.type = "image/svg+xml";
		link.rel = "icon";
		link.href = faviconPath;

		// kalau belum ada link favicon, tambahkan ke head
		if (!link.parentNode) {
			document.head.appendChild(link);
		}
	}, [faviconPath]);
}
